import { useEffect } from 'react';
import { useRouter } from 'next/router';
import SeoHead, {
  DEFAULT_META_DESCRIPTION,
  DEFAULT_META_TITLE,
} from '../../components/common/SeoHead';

export default function StayExperience() {
  const router = useRouter();

  // Redirect to chat screen on mount
  useEffect(() => {
    router.replace('/chat');
  }, [router]);

  return (
    <SeoHead
      title={DEFAULT_META_TITLE}
      description={DEFAULT_META_DESCRIPTION}
      path='/stay-experience'
      disableTitleSuffix
    />
  );
}
